<form #form="ngForm">
    <div class="row">
        <div class="col-xl-12">
            <div class="form-group row py-0">
                <div class="col-12 col-xl-4 col-md-6">
                    <div class="d-flex flex-column form-group py-0">
                        <label class="form-control-label" for="edit-pageTitle">Page title</label>
                        <input type="text"
                               name="pageTitle"
                               class="form-control"
                               [(ngModel)]="post.title"
                               #postTitle="ngModel"
                               required
                               id="edit-pageTitle">
						<div class="form-control-error"
							*ngIf="!postTitle.valid && (postTitle.touched || state.isSubmitted)">
						   <ul>
							   <li *ngIf="postTitle?.errors?.required">Page title is required.</li>
						   </ul>
					   </div>
                    </div>
                </div>
				
                <div class="form-group col-12 col-xl-4 col-md-6">
                    <label class="form-label">Post Status</label>
                    <h4 class="mb-0 draft-published" *ngIf="post.status === 'Published'"><span class="badge lg badge-success">Published</span></h4>
                    <h4 class="mb-0 draft-published" *ngIf="post.status === 'Draft'"><span class="badge lg badge-warning">Draft</span></h4>
                    <h4 class="mb-0 draft-published" *ngIf="!post.status"><span class="badge lg badge-warning">Unpublished</span></h4>
                </div>
            </div>
        </div>
    </div>
	<div class="editor-wrapper">
		<ckeditor
				*ngIf="!isMobile"
				#postEditor
				name="pageBody"
				[(ngModel)]="post.html"
				(ngModelChange)="updateLinks()"
				#pageBody="ngModel"
				[config]="ckeditorDesktopConfig"
				[readonly]="false"
				debounce="500">
			<ckbutton
					[name]="'image'"
					[command]="'openImageExplorer'"
					(click)="openImageExplorer()"
					[label]="'Open image explorer'"
					[toolbar]="'insert,0'">
			</ckbutton>
		</ckeditor>
		<ckeditor
				*ngIf="isMobile"
				#postEditor
				name="pageBody"
				[(ngModel)]="post.html"
				(ngModelChange)="updateLinks()"
				#pageBody="ngModel"
				[config]="ckeditorMobileConfig"
				[readonly]="false"
				debounce="500">
			<ckbutton
					[name]="'image'"
					[command]="'openImageExplorer'"
					(click)="openImageExplorer()"
					[label]="'Open image explorer'"
					[toolbar]="'insert,0'">
			</ckbutton>
		</ckeditor>
	</div>
</form>
<div class="row d-flex justify-content-end mt-4 mr-0">
    <div class="d-flex align-items-center">
        <button class="btn btn-outline-primary btn-block mr-2" (click)="cancel()">Cancel</button>
        <button class="btn btn-primary mr-2" [disabled]="saving" (click)="save(false)">Save as Draft</button>
        <button class="btn btn-primary" [disabled]="saving" (click)="save(true)">Publish</button>
    </div>
</div>
